// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-207ad9b9] {\n  margin-bottom: 20px;\n}\n.icon span[data-v-207ad9b9] {\n  font-size: 64px;\n  color: #e3003a;\n}\n.title[data-v-207ad9b9] {\n  font-size: 24px;\n  color: #000;\n  font-weight: 400;\n  max-width: 266px;\n}\n.description[data-v-207ad9b9] {\n  font-size: 16px;\n  color: #6a6b6a;\n  font-weight: 500;\n  max-width: 322px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
